<template>
  <div
    v-if="$store.getters.isRtbFlowPossible && data && (data.perHour || data.perDay)"
    class="h-full text-base flex flex-col justify-around"
  >
    <div v-if="data.perHour">
      <template v-if="data.perHour.hasOther">
        from
      </template>
      <span class="font bold">{{ data.perHour.price.formatted }}</span> / hour
    </div>
    <div v-if="data.perDay">
      <template v-if="data.perDay.hasOther">
        from
      </template>
      <span class="font bold">{{ data.perDay.price.formatted }}</span> / day
    </div>
  </div>
</template>

<script>

export default {
  name: 'EnquiryPricingMobileBar',
  computed: {
    data() {
      return this.$store.state.minimumPricing;
    },
  },
};
</script>
